module.exports = __webpack_public_path__ + "img/red-2-squiggly-striped.7440c37d.svg";